import { Variant } from '@mui/material/styles/createTypography';
import { CheckboxStyle } from 'components/molecules/FormCheckbox/styles';
import { AccountType } from 'constants/AccountType';

export interface IFormElementOptionProp {
  label: string;
  value: string | number;
}

export interface IFormElementProps {
  name: string;
  label?: string;
  labelElement?: any;
  control: any;
  errors: any;
  withValidation?: boolean;
  disabled?: boolean;
  onChange?: (arg: boolean) => void;
  labelVariant?: Variant;
  style?: CheckboxStyle;
}

export const initialLoginFormValues = {
  email: '',
  password: '',
  type: null,
};

export const initialIndividualCreateFormValues: IAccountCreateFormValues = {
  email: '',
  prefixPhoneNumberUniqueId: '',
  phoneNumber: '',
  dateOfBirth: '',
  type: null,
  termsAndConditions: false,
};
export const initialCommercialOrganisationCreateFormValues: IAccountCreateFormValues = {
  email: '',
  phoneNumber: '',
  type: null,
};

export interface IAccountCreateFormValues {
  email: string;
  prefixPhoneNumberUniqueId?: string;
  phoneNumber: string;
  dateOfBirth?: string;
  type: AccountType | null;
  termsAndConditions?: boolean;
}

export const initialTwoFactorAuthFormValues: ITwoFactorAuthForm = {
  authCode: '',
  isRememberDevice: false,
  trustedDeviceTimeOptionUniqueId: undefined,
};

export interface ITwoFactorAuthForm {
  authCode: string;
  isRememberDevice: boolean;
  trustedDeviceTimeOptionUniqueId: string | undefined;
}

export const initialForgotPasswordFormValues = {
  email: '',
};

export const initialSetPasswordFormValues = {
  newPassword: '',
};

export interface IAccountDataFormValues {
  email: string;
  retypeEmail: string;
  prefixPhoneNumberUniqueId?: string;
  phoneNumber: string;
  notificationSms: boolean;
  notificationEmail: boolean;
}

export const initialAccountDataFormValues: IAccountDataFormValues = {
  email: '',
  retypeEmail: '',
  prefixPhoneNumberUniqueId: '',
  phoneNumber: '',
  notificationEmail: false,
  notificationSms: false,
};

export interface IAccountDataFormConfirmValues {
  code: string;
}

export const initialAccountDataFormConfirmValues: IAccountDataFormConfirmValues = {
  code: '',
};
